/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Student } from '../../models/student';
import { UpdateStudentNicknameDto } from '../../models/update-student-nickname-dto';

export interface IlsControllerUpdateStudentNickname$Params {
  ilsId: string;
  studentId: string;
      body: UpdateStudentNicknameDto
}

export function ilsControllerUpdateStudentNickname(http: HttpClient, rootUrl: string, params: IlsControllerUpdateStudentNickname$Params, context?: HttpContext): Observable<StrictHttpResponse<Student>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerUpdateStudentNickname.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('studentId', params.studentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Student>;
    })
  );
}

ilsControllerUpdateStudentNickname.PATH = '/ils/{ilsId}/student/{studentId}/nickname';
